<ul sd-list-inline class="is-m">
  @for (savedAddress of savedAddressList; track savedAddress) {
    <li data-testid="list">
      <sd-address-card [title]="$first ? ('checkout.address.chooseAddress' | translate: {reason: title}) : ''"
        [titleLevel]="titleLevel"
        [isSelectable]="true"
        (edit)="editAddress(savedAddress)"
        #addressCardSelectable
        (addressSelected)="selectChange(savedAddress)"
        [address]="savedAddress"
        data-testid="card"
      />
    </li>
  }
  <li>
    <div class="c__empty-address">
      <button sd-button [isSecondary]="true" icon="icon-plus" (click)="createAddress()" data-testid="create-btn">
        <span>{{ 'checkout.address.actions.create' | translate}}</span>
      </button>
    </div>
  </li>
</ul>

<button sd-button class="c__choose-selected" (click)="chooseSelectedAddress()" data-testid="choose-btn">
  {{ 'checkout.address.actions.choose' | translate}}
</button>
